<!--
 * @FileDescription: 退款失败提示对话框
 * @Author: 陈文景
 * @Date: 2022-11-07 18:11:51
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :visible.sync="visible" :width="`${width}px`" :before-close="close">
    <div class="tips">
      <i class="el-icon-error" />
      <p class="title">{{ $t('orderRefund.RefundRequestFailed') }}</p>
      <p class="subheading">
        {{ $t('orderRefund.ThereIsErrorWithYouRequest') }}<br />
        {{ $t('orderRefund.PleaseConnectOurSupportTeam') }}
      </p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" @click="confirm">{{ $t('orderRefund.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      width: 330,
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },

    confirm() {
      this.close()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {}
  }
}
</script>

<style lang="scss" scoped>
.tips {
  text-align: center;
  .el-icon-error {
    color: #a6100c;
    font-size: 45px;
  }
  .title {
    color: #000000;
    font-size: 16px;
    padding: 15px 0;
  }
  .subheading {
    color: #a6100c;
    font-size: 14px;
  }
}

/deep/.el-dialog {
  border-radius: 6px !important;
  .el-dialog__header {
    padding: 15px;
  }
  .el-dialog__body {
    padding: 15px;
  }
  .el-dialog__headerbtn {
    top: 15px;
    right: 15px;
  }
}

.dialog-footer {
  text-align: center;
}
</style>
